// extracted by mini-css-extract-plugin
module.exports = {"slide":"PopularCategoryList_slide__ZGi5Z","active":"PopularCategoryList_active__WYnrl"};